import { Toast } from 'antd-mobile'

const ToastMessage = ({ toastMessage, clearToast }) => {
  if (toastMessage) Toast.info(toastMessage, 2.5, () => clearToast())
  return null
}

export default ToastMessage
